import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
    listData: null,
    page: 0,
    pageCount: 0,
    totalCount: 0,
    loading: false,
    createSuccess: false,
    cancelSuccess: false,
    error: null,
};

const bigPrizeAssignmentsSlice = createSlice({
    name: "bigPrizeAssignments",
    initialState,
    reducers: {
        getListRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        getListSuccess: (state, action) => {
            state.loading = false;
            state.listData = action.payload.data;
            state.page = action.payload.current_page;
            state.pageCount = action.payload.page_count;
            state.totalCount = action.payload.total_count;
        },
        getListFail: (state, action) => {
            state.loading = false;
            state.listData = null;
            state.page = 0;
            state.pageCount = 0;
            state.totalCount = 0;
            state.error = action.payload;
        },
        createRequest: (state) => {
            state.loading = true;
            state.createSuccess = false;
            state.error = null;
        },
        createSuccessAction: (state) => {
            state.loading = false;
            state.createSuccess = true;
        },
        createFail: (state, action) => {
            state.loading = false;
            state.createSuccess = false;
            state.error = action.payload;
        },
        cancelRequest: (state) => {
            state.loading = true;
            state.cancelSuccess = false;
            state.error = null;
        },
        cancelSuccessAction: (state) => {
            state.loading = false;
            state.cancelSuccess = true;
        },
        cancelFail: (state, action) => {
            state.loading = false;
            state.cancelSuccess = false;
            state.error = action.payload;
        },
        resetCreateSuccess: (state) => {
            state.createSuccess = false;
        },
        resetCancelSuccess: (state) => {
            state.cancelSuccess = false;
        },
        resetState: () => initialState,
    },
});

export const {
    getListRequest,
    getListSuccess,
    getListFail,
    createRequest,
    createSuccessAction,
    createFail,
    cancelRequest,
    cancelSuccessAction,
    cancelFail,
    resetCreateSuccess,
    resetCancelSuccess,
    resetState,
} = bigPrizeAssignmentsSlice.actions;

// Thunks
export const doGetBigPrizeAssignmentsList = (params) => async (dispatch) => {
    dispatch(getListRequest());
    try {
        const config = {
            params: {
                page: params.page || 1,
                size: params.size || 20,
                ...params,
            },
        };

        Object.keys(config.params).forEach((key) => {
            if (config.params[key] === undefined || config.params[key] === null || config.params[key] === "") {
                delete config.params[key];
            }
        });

        const response = await axios.get(`/api/admin/big-prize-assignments`, config);

        dispatch(getListSuccess({
            data: response.data.data,
            current_page: response.data.current_page,
            page_count: response.data.page_count,
            total_count: response.data.total_count,
        }));
    } catch (error) {
        dispatch(getListFail(error.response?.data?.message || "Failed to fetch big prize assignments"));
    }
};

export const doCreateBigPrizeAssignment = (data) => async (dispatch) => {
    dispatch(createRequest());
    try {
        await axios.post(`/api/admin/big-prize-assignments`, data);
        dispatch(createSuccessAction());
    } catch (error) {
        dispatch(createFail(error.response?.data?.message || "Failed to create big prize assignment"));
    }
};

export const doCancelBigPrizeAssignment = (assignmentId) => async (dispatch) => {
    dispatch(cancelRequest());
    try {
        await axios.put(`/api/admin/big-prize-assignments/${assignmentId}/cancel`);
        dispatch(cancelSuccessAction());
    } catch (error) {
        dispatch(cancelFail(error.response?.data?.message || "Failed to cancel big prize assignment"));
    }
};

// Selectors
export const getBigPrizeAssignmentsList = (state) => state.bigPrizeAssignments.listData;
export const getBigPrizeAssignmentsPage = (state) => state.bigPrizeAssignments.page;
export const getBigPrizeAssignmentsPageCount = (state) => state.bigPrizeAssignments.pageCount;
export const getBigPrizeAssignmentsTotalCount = (state) => state.bigPrizeAssignments.totalCount;
export const getBigPrizeAssignmentsLoading = (state) => state.bigPrizeAssignments.loading;
export const getBigPrizeAssignmentsCreateSuccess = (state) => state.bigPrizeAssignments.createSuccess;
export const getBigPrizeAssignmentsCancelSuccess = (state) => state.bigPrizeAssignments.cancelSuccess;
export const getBigPrizeAssignmentsError = (state) => state.bigPrizeAssignments.error;

export default bigPrizeAssignmentsSlice.reducer;
